document.addEventListener("DOMContentLoaded", () => {
  handleMenu();
});

// Handle Menu
const handleMenu = () => {
  const hamburger = document.querySelector(".hamburger");
  const nav = document.querySelector(".nav");
  const navItems = document.querySelectorAll(".nav ul li a");
  const announce = document.querySelector(".common-announce");
  const header = document.querySelector(".header");

  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("is-open");
    nav.classList.toggle("is-open");
    announce.classList.toggle("is-hidden");
    header.classList.toggle("is-menu-open");
  });

  const items = document.querySelectorAll(".menu-item-has-children");

  items.forEach((item) => {
    item.addEventListener("click", (e) => {
      if (e.target.tagName.toLowerCase() === "a") return;

      const isOpen = item.classList.contains("is-open");

      items.forEach((el) => el.classList.remove("is-open"));

      if (!isOpen) {
        item.classList.add("is-open");
      }
    });
  });

  navItems.forEach((item) => {
    item.addEventListener("click", () => {
      nav.classList.toggle("is-open");
      hamburger.classList.toggle("is-open");
      announce.classList.toggle("is-hidden");
      header.classList.toggle("is-menu-open");
    });
  });
};